<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" persistent primary-title>
      {{ payload.material.materialName }}
    </v-card-title>
    <v-card-text>
      <v-text-field
        ref="quantity"
        :label="payload.material.unit"
        name="quantity"
        v-model="quantity"
        type="number"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click.stop="cancel" :disabled="submitted">Fermer</v-btn>
      <v-btn color="primary" variant="text" :disabled="quantity <= 0 || submitted" @click.stop="confirm">
        Remplacer par matériau
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { UpdateMaterial } from '@/_services/materials';
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { stepperMixin } from '@/classes/helper/stepperHelper';

export default {
  name: 'MaterialQuantityDialog',
  mixins: [DialogPropsMixin, stepperMixin],
  data() {
    return {
      quantity: 0,
      submitted: false,
    };
  },
  mounted() {
    this.quantity = this.payload.material.quantity;
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('loading');
      UpdateMaterial(this.payload.material.id, this.quantity)
        .then(res => {
          this.$store.dispatch('job/updateMaterial', {
            compositeId: this.payload.compositeId,
            material: res,
            phaseId: this.payload.phaseId,
          });
        })
        .catch(error => {
          this.$store.dispatch('snackbar/set', error);
        })
        .finally(() => {
          this.updateTotalCost(this.$store.getters['submission/getJobId'])
            .catch(error => {
              this.$store.dispatch('snackbar/set', error);
            })
            .finally(() => {
              this.$emit('loading', false);
              this.$emit('close');
            });
        });
    },
  },
};
</script>
